import {Product} from "@app/core/product/domain/dtos/product";
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";
import {ShareProductsComponent} from "@app/presentation/pages/share-products/share-products.component";
import {
    DesktopModalType,
    MobileModalType,
    ModalConfig,
    ModalService
} from "@app/presentation/services/modal/modal.service";
import {ToastService} from "@app/presentation/services/toast/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {CartLine} from "@app/core/cart/domain/dtos/cart-line";

@Injectable({
    providedIn: 'root'
})
export class ShareProductsModalService {

    constructor(
        private modalService: ModalService,
        private toastService: ToastService,
        private translateService: TranslateService,
    ) {}

    openModal(products: Product[]): Observable<void> {
        const hasProductsToShare = products.length > 0;
        if (!hasProductsToShare) {
            this.toastService.show(this.translateService.instant('share_products.no_products_to_share'));
            return of();
        }

        const modalConfig: ModalConfig = {
            data: { products: products },
            mobileModalType: MobileModalType.BOTTOM_SHEET,
            desktopModalType: DesktopModalType.SIDE_SHEET,
        };
        return this.modalService.open(ShareProductsComponent, modalConfig);
    }

    shareCartLines(cartLines: CartLine[]): Observable<void> {
        const onlyProductsCartLines = cartLines.filter(cartLine => cartLine.promotionCode == '');
        const products: Product[] = onlyProductsCartLines.map(cartLine => ({
            code: cartLine.code,
            name: cartLine.name,
            image: cartLine.image,
            price: cartLine.price,
            units: cartLine.units,
            unitPrice: cartLine.unitPrice,
            palletPrice: cartLine.palletPrice,
        }));
        if (products.length == 0) {
            this.toastService.show(this.translateService.instant('share_products.promotions_not_shareable'));
            return of();
        }
        return this.openModal(products);
    }
}